import type { HTMLAttributes } from "react";
import { cn } from "../cn.js";

interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: "default" | "high" | "medium" | "low" | "muted";
}

export function Badge({ className, tone = "default", ...props }: BadgeProps) {
  const toneClass = {
    default: "bg-secondary text-secondary-foreground",
    high: "bg-red-500/15 text-red-600 dark:text-red-400",
    medium: "bg-amber-500/15 text-amber-600 dark:text-amber-400",
    low: "bg-blue-500/15 text-blue-600 dark:text-blue-400",
    muted: "bg-muted text-muted-foreground",
  }[tone];
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium",
        toneClass,
        className,
      )}
      {...props}
    />
  );
}
